/* FansFirst - carrito (v29, SIMPLIFICADO).
   Base: v27/v28. v29 (2026-09-10): auto-continuar anti-parpadeo + reintento (ver bloque).
   v27 (2026-09-10): AUTO-CONTINUAR al pago tras el cuestionario de Evey, A PRUEBA
   DE FALLOS. Hoy: el comprador da Pagar, llena el cuestionario, Evey lo cierra y hay
   que volver al carrito y dar Pagar OTRA VEZ (ese segundo clic si pasa porque Evey ya
   tiene los datos). Aqui damos ese segundo clic por el:
     - SOLO si el comprador envio el cuestionario (clic en el boton de Evey),
     - SOLO cuando Evey ya cerro su ventana,
     - y SOLO cuando /cart.js confirma que los datos del asistente YA estan guardados
       en las lineas del carrito (propiedades "_evey:attendee..."). Esto es lo que
       faltaba en v22-24 y por eso se atoraban: disparaban antes de tiempo.
     - Una sola vez. Si en ~6 s no se cumple, NO hace nada: el comprador da Pagar a
       mano como hoy. Nunca oculta, nunca bloquea, nunca reintenta => el peor caso
       es exactamente el flujo actual.
   El pago se dispara con el envio NATIVO del formulario del carrito (requestSubmit
   sobre #checkout / #cart-form), no navegando a /checkout (eso mandaba al login).

   Historia: v21 quito toda la logica que peleaba con Evey y con la casilla del fee
   (fee en modo "Oculto" en VOL). v25 quito el sello "GRATIS". v26 cierra el cajon al
   abrir Evey (fix de celular: el <dialog> tapaba el cuestionario).
   Queda:
   1) Check obligatorio "no incluye boleto": bloquea PAGAR hasta marcarlo.
   2) La camiseta DENTRO del renglon del boleto (talla fija, sin sello de gratis).
   3) Auto-aceptar el modal viejo #disclaimer-modal si llegara a aparecer.
   4) Cerrar el cajon cuando aparece el cuestionario de Evey.
   5) Auto-continuar al pago tras el cuestionario (a prueba de fallos). */
(function () {
  var KEY = 'ff_cart_ack';

  function box() { return document.getElementById('cart-ack-input'); }
  function checkoutBtn() { return document.getElementById('checkout'); }
  function isAck() { try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
  function setAck(v) { try { sessionStorage.setItem(KEY, v ? '1' : '0'); } catch (e) {} }

  /* ---- Camiseta DENTRO del renglon del boleto (sin sello de gratis) ---- */
  var SHIRT_KEYS = ['camiseta', 't-shirt', 'tshirt'];

  function injectShirtStyles() {
    if (document.getElementById('ff-shirt-style')) return;
    var st = document.createElement('style');
    st.id = 'ff-shirt-style';
    st.textContent =
      '.cart-items__table-row[data-ff-shirt] .quantity-selector,' +
      '.cart-items__table-row[data-ff-shirt] cart-quantity-selector-component,' +
      '.cart-items__table-row[data-ff-shirt] .volume-pricing-info{display:none !important}' +
      '.ff-qty-fixed{font-weight:600;white-space:nowrap;padding-inline:4px}' +
      '#evey-attendee-info-modal .evey-attendee-info-submit:hover:not([disabled]):not(.disabled):not([aria-disabled="true"])' +
      '{background-color:#0A0A0C !important;color:#F1EDE4 !important;border-color:#0A0A0C !important}' +
      '#evey-attendee-info-modal .evey-attendee-info-submit[disabled],' +
      '#evey-attendee-info-modal .evey-attendee-info-submit.disabled,' +
      '#evey-attendee-info-modal .evey-attendee-info-submit[aria-disabled="true"]' +
      '{background-color:#D6D1C6 !important;color:#7C8087 !important;border-color:#D6D1C6 !important;cursor:not-allowed}';
    document.head.appendChild(st);
  }

  function decorateShirtLines() {
    var rows = document.querySelectorAll('.cart-items__table-row');
    for (var r = 0; r < rows.length; r++) {
      var row = rows[r];
      if (row.getAttribute('data-ff-shirt-done') === '1') continue;

      var props = row.querySelectorAll('.cart-items__properties');
      var hitEl = null, hitName = '', hitValue = '';
      for (var i = 0; i < props.length; i++) {
        var dt = props[i].querySelector('dt');
        var dd = props[i].querySelector('dd');
        if (!dt || !dd) continue;
        var raw = (dt.textContent || '').replace(/:\s*$/, '').trim();
        if (SHIRT_KEYS.indexOf(raw.toLowerCase()) === -1) continue;
        hitEl = props[i]; hitName = raw; hitValue = (dd.textContent || '').trim();
      }
      if (!hitEl) continue;

      row.setAttribute('data-ff-shirt-done', '1');
      row.setAttribute('data-ff-shirt', '1');
      hitEl.style.display = 'none';

      var line = document.createElement('p');
      line.className = 'ff-cart-shirt';
      var a = document.createElement('span');
      a.textContent = '+ ' + hitName + ': ' + hitValue;
      line.appendChild(a);

      var dl = hitEl.closest('dl');
      if (dl && dl.parentNode) dl.parentNode.insertBefore(line, dl);
      else hitEl.parentNode.insertBefore(line, hitEl);

      var controls = row.querySelector('.cart-items__quantity-controls');
      if (controls && !controls.querySelector('.ff-qty-fixed')) {
        var qtyEl = row.querySelector('.cart-items__quantity input[name="quantity"], .cart-items__quantity input');
        var n = qtyEl ? (qtyEl.value || qtyEl.getAttribute('value') || '1') : '1';
        var tag = document.createElement('span');
        tag.className = 'ff-qty-fixed';
        tag.textContent = '× ' + n;
        controls.insertBefore(tag, controls.firstChild);
      }
    }
  }

  /* ---- El check "no incluye boleto" se mantiene marcado entre redibujados ---- */
  function sync() {
    var b = box();
    var ack = isAck();
    if (b) b.checked = ack;
    var btn = checkoutBtn();
    if (btn) btn.classList.toggle('is-locked', !ack);
  }

  document.addEventListener('change', function (e) {
    if (!e.target || e.target.id !== 'cart-ack-input') return;
    setAck(e.target.checked);
    var err = document.querySelector('.cart-ack__error');
    if (err && e.target.checked) err.hidden = true;
    sync();
  });

  /* ---- UNICO gate: no dejar PAGAR sin marcar "no incluye boleto" ----
     Si esta marcado, NO interferimos: Evey y el checkout corren nativos como en el
     tema original. Solo bloqueamos cuando falta el check. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('#checkout');
    if (!btn) return;
    if (isAck()) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var b = box();
    var wrap = (b && b.closest('.cart-ack')) || document.querySelector('.cart-ack');
    if (wrap) { wrap.classList.remove('is-shake'); void wrap.offsetWidth; wrap.classList.add('is-shake'); }
    var err = document.querySelector('.cart-ack__error'); if (err) err.hidden = false;
    try { b && b.focus({ preventScroll: false }); } catch (x) {}
  }, true);

  /* ---- Modal viejo #disclaimer-modal: auto-aceptar si llegara a salir ---- */
  var disclaimerHandled = false;
  function maybeAutoAcceptDisclaimer() {
    var modal = document.getElementById('disclaimer-modal');
    if (!modal) { disclaimerHandled = false; return; }
    var visible = modal.style.display !== 'none' && modal.offsetParent !== null;
    if (!visible) { disclaimerHandled = false; return; }
    if (disclaimerHandled) return;
    disclaimerHandled = true;
    var confirmBtn = document.getElementById('disclaimer-confirm');
    try { confirmBtn && confirmBtn.click(); } catch (x) {}
  }

  /* ---- Cuestionario de Evey: senal fiable de "esta abierto" ----
     El boton de envio (.evey-attendee-info-submit) existe y es visible mientras el
     cuestionario esta abierto; desaparece/oculta cuando Evey cierra. */
  function eveyOpen() {
    var sub = document.querySelector('.evey-attendee-info-submit');
    if (!sub) return false;
    var cs = window.getComputedStyle(sub);
    if (cs.display === 'none' || cs.visibility === 'hidden') return false;
    var r = sub.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  /* ---- FIX celular: si el cuestionario de Evey esta a la vista, cerrar el cajon ----
     Cerramos el <dialog> del carrito con .close() nativo (comp.close() no basta).
     Solo cerramos; nunca reabrimos. */
  function closeDrawerForEvey() {
    if (!eveyOpen()) return;
    var dlg = document.querySelector('dialog.cart-drawer__dialog');
    if (dlg && dlg.open) {
      try { dlg.close(); } catch (x) {}
    }
  }

  /* ---- AUTO-CONTINUAR al pago tras el cuestionario (a prueba de fallos, v29) ----
     Por que fallaron v27/v28 en el flujo real:
       - Evey re-dibuja su boton de envio mientras el comprador escribe; un parpadeo
         de ~100 ms hacia creer "se cerro" a mitad del llenado, se arrancaba el reloj
         antes de tiempo y se quedaba puesto un candado => al enviar de verdad, nada.
       - Al guardar, el tema re-dibuja el cajon y #checkout desaparece un instante;
         si el disparo caia ahi, no habia boton y no se reintentaba.
     v29:
       - "Cerrado" solo cuenta si lleva >= 800 ms cerrado de forma continua (anti-parpadeo).
       - Sin candado pegajoso: cada envio (click/touch/pointer en el boton de Evey)
         deja una intencion pendiente que se consume SOLO cuando el pago se dispara.
       - Ruta sin click (celular): si al abrir NO habia datos del asistente y al cerrar
         SI aparecen, tambien dispara (cancelar no agrega datos => no pasa nada).
       - Reintenta hasta encontrar #checkout (el cajon puede estar re-dibujandose).
       - Espera hasta ~20 s a que Evey guarde. Tope duro: 3 disparos por pagina.
       - Estado visible en window.__ffCart para diagnostico en vivo.
     Nunca oculta, nunca bloquea: el peor caso es el flujo actual (dar Pagar a mano). */
  var ST = { pending: false, closedSince: 0, hadPropsBefore: null, polling: false, fired: 0, last: '' };
  try { window.__ffCart = ST; } catch (x) {}

  window.addEventListener('pageshow', function (e) {
    if (e && e.persisted) { ST.pending = false; ST.closedSince = 0; ST.hadPropsBefore = null; ST.polling = false; ST.last = 'pageshow-reset'; }
  });

  function markSubmit(e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest('.evey-attendee-info-submit')) { ST.pending = true; ST.last = 'submit-intent:' + e.type; }
  }
  ['click', 'pointerup', 'touchend'].forEach(function (ev) {
    document.addEventListener(ev, markSubmit, { capture: true, passive: true });
  });

  function cartHasAttendee(cb) {
    try {
      fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (c) {
        var ok = false;
        var items = (c && c.items) || [];
        for (var i = 0; i < items.length && !ok; i++) {
          var p = items[i].properties || {};
          for (var k in p) { if (k.indexOf('_evey:attendee') === 0) { ok = true; break; } }
        }
        cb(ok);
      }).catch(function () { cb(false); });
    } catch (x) { cb(false); }
  }

  /* Devuelve true solo si encontro el boton y disparo el envio nativo. */
  function nativeCheckout() {
    var btn = checkoutBtn();
    if (!btn) return false;
    var form = document.getElementById('cart-form') || btn.form;
    try {
      if (form && typeof form.requestSubmit === 'function') { form.requestSubmit(btn); return true; }
    } catch (x) {}
    try { btn.click(); return true; } catch (x) {}
    return false;
  }

  function maybeAutoContinue() {
    var open = eveyOpen();
    if (open) {
      ST.closedSince = 0;
      if (ST.hadPropsBefore === null) {
        ST.hadPropsBefore = 'loading';
        cartHasAttendee(function (ok) { ST.hadPropsBefore = ok; });
      }
      return;
    }
    /* cerrado */
    if (!ST.closedSince) { ST.closedSince = Date.now(); return; }
    if (Date.now() - ST.closedSince < 800) return; /* anti-parpadeo */
    if (ST.polling) return;
    var wants = ST.pending || ST.hadPropsBefore === false;
    if (!wants) return;
    if (ST.fired >= 3) return;

    ST.polling = true;
    ST.last = 'poll-start';
    var tries = 0;
    (function poll() {
      cartHasAttendee(function (ok) {
        var go = ok && (ST.pending || ST.hadPropsBefore === false);
        if (go) {
          if (nativeCheckout()) {
            ST.fired++; ST.pending = false; ST.hadPropsBefore = null; ST.polling = false; ST.last = 'fired';
            return;
          }
          /* sin boton todavia (cajon re-dibujandose): reintentar */
        }
        if (++tries < 40) { setTimeout(poll, 500); return; } /* hasta ~20 s */
        ST.polling = false; ST.pending = false; ST.hadPropsBefore = null; ST.last = 'gave-up';
      });
    })();
  }

  var raf = null;
  function scheduleSync() {
    if (raf) return;
    raf = requestAnimationFrame(function () {
      raf = null;
      sync();
      maybeAutoAcceptDisclaimer();
      decorateShirtLines();
      closeDrawerForEvey();
      maybeAutoContinue();
    });
  }
  new MutationObserver(scheduleSync).observe(document.documentElement, {
    childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'class', 'style']
  });
  /* Red de seguridad: Evey abre/cierra de forma asincrona; chequeo ligero cada 300ms. */
  setInterval(function () { closeDrawerForEvey(); maybeAutoContinue(); }, 300);

  function boot() { injectShirtStyles(); sync(); decorateShirtLines(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
